export default "__VITE_ASSET__Am1$4r2m__"